module.exports = __webpack_public_path__ + "img/logo-h.a517b243.png";